<template>
  <div class="set-address">
    <div class="set-address-inset">
      <div class="title">
        購入
      </div>
      <div class="msg-area">
        <div class="input-area">
          <el-form
            ref="form"
            :model="form"
            label-width="100px"
          >
            <el-form-item label="郵便番号">
              <el-input v-model="code"></el-input>
            </el-form-item>
            <el-form-item label="国\地域">
              <el-input v-model="country"></el-input>
            </el-form-item>
            <el-form-item label="市">
              <el-input v-model="city"></el-input>
            </el-form-item>
            <el-form-item label="住所">
              <el-input v-model="address"></el-input>
            </el-form-item>
            <el-form-item label="氏名">
              <el-input v-model="name"></el-input>
            </el-form-item>
            <el-form-item label="電話番号">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item label="E-mail">
              <el-input v-model="email"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tips-area">
          必要事項を入力し、「この住所を使う」ボタンをクリックしてください。
          <br /><br />
          国内の住所：<br />
          半角、全角文字を使用できます（半角2文字で全角1文字分）<br />
          国外の住所：<br />
          半角文字の英数字のみ使用できます。
          <br /><br />
          ※特殊文字は使用できません。<br />
          ※確実にお届けするため、必ずフルネームを入力下さい。<br />
          ※私書箱や空港内の窓口へのお届けは承っておりません。<br />
          ※コンビニ、営業所、空港の宅配サービスカウンターなどの住所を入力すると商品をお受け取りいただけません。
          <br /><br />
          <ul class="tips">
            <li>プライバシーの保護</li>
            <li>情報セキュリティ</li>
            <li>３Ｄセキュア</li>
          </ul>
        </div>
      </div>
    </div>
    <button
      class="to-buy"
      @click="toBuy()"
    >
      この住所を使う
    </button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      form: {
        
      },
      code: null,
      country: null,
      city: null,
      address: null,
      name: null,
      phone: null,
      email: null
    }
  },
  methods: {
    toBuy () {
      let data = JSON.parse(localStorage.getItem('orderMsg'))
      data.address = {}
      data.address = {
        method : 'add',
        code: this.code,
        country: this.country,
        city: this.city,
        address: this.address,
        name: this.name,
        phone: this.phone,
        email: this.email
      }
      this.$axios({
         method:'post',
         url:'http://203.85.72.1/forcecms_zhongyin20180515/h5/managerAddress',//http://203.85.72.1/forcecms_zhongyin20180515
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:data.address
      }).then(res =>{
        localStorage.setItem('addressId',res.data.addressId)
        localStorage.setItem('orderMsg', JSON.stringify(data))
        this.$emit('toBuy')
      })
    },
  },
  mounted () {
  }
}
</script>
<style scoped>
.set-address {
  width: 100%;
  min-width: 1100px;
}
.set-address-inset {
  width: 1100px;
  margin: 0 auto;
  padding: 50px 0;
}
.title {
  font-weight: bold;
  font-size: 35px;
  color: #39d8cc;
  margin-bottom: 15px;
}
.msg-area {
  width: 1100px;
  display: flex;
}
.input-area {
  flex: 1;
  margin-right: 40px;
}
.tips-area {
  flex: 1;
}
* >>> .el-form-item__label {
  font-weight: bold;
  font-size: 20px;
}
.tips-area {
  font-size: 14px;
  color: #7f7f7f;
}
.tips {
  padding-inline-start: 20px;
  color: #39d8cc;
  text-decoration: underline;
  font-size: 20px;
  font-weight: bold;
}
.tips li {
  cursor: pointer;
}
.to-buy {
  width: 350px;
  height: 50px;
  background: #39d8cc;
  box-shadow: 0px 1px 40px 0px rgba(57, 216, 204, 0.24);
  border-radius: 4px;
  outline: none;
  border: none;
  display: block;
  margin: 0px auto;
  margin-bottom: 50px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.to-buy:active {
  background: #3efaec;
}
</style>


// WEBPACK FOOTER //
// src/components/buy/modules/set-address.vue